import React from 'react'
import './HrinigProcedure.css'
import "bootstrap/dist/css/bootstrap.min.css";
import hiring from "../../../../Assets/Images/Services/Dev For Hire/Hiring.svg"
import c1 from "../../../../Assets/Images/Services/Dev For Hire/C1.svg"
import c2 from "../../../../Assets/Images/Services/Dev For Hire/C2.svg"
import c3 from "../../../../Assets/Images/Services/Dev For Hire/C3.svg"
import c4 from "../../../../Assets/Images/Services/Dev For Hire/C4.svg"
import c5 from "../../../../Assets/Images/Services/Dev For Hire/C5.svg"
import c6 from "../../../../Assets/Images/Services/Dev For Hire/C6.svg"

export const HiringProcedure = () => {
  return (
    <div id='hire-process' className='d-flex flex-column justify-content-center hp text-center'>
        <h1 className='hp-title'>How The Hiring Process Works</h1>
        <div className='hp-container'>
            <div className="hp-img">
                <img src={hiring} alt="hiring" className="img-fluid" />
            </div>
            <div className="hp-proc ">
                <ul className='d-flex flex-column justify-content-between'>
                    <li className='d-flex align-items-center'> <img src={c1} alt="" className='img-fluid' /><p>Get requirements from you</p></li>
                    <li className='d-flex align-items-center'> <img src={c2} alt="" className='img-fluid' /><p>Careful CV screening</p></li>
                    <li className='d-flex align-items-center'> <img src={c3} alt="" className='img-fluid' /><p>Soft skills evaluation</p></li>
                    <li className='d-flex align-items-center'> <img src={c4} alt="" className='img-fluid' /><p>PM or Team Lead interview</p></li>
                    <li className='d-flex align-items-center'> <img src={c5} alt="" className='img-fluid' /><p>Technical skill assessment</p></li>
                    <li className='d-flex align-items-center'> <img src={c6} alt="" className='img-fluid' /><p>Final CTO interview</p></li>
                </ul>
            </div>
        </div>
    </div>
  )
}
